var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 710.935,
    height: 550.149,
    viewBox: "0 0 710.935 550.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.302,
    x2: 0.5,
    y2: 0.645,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2eed3",
    stopOpacity: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2eed3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M180.7,247.414l.179-8.075,73.037-.538-.179,8.255Z",
    transform: "translate(-180.7 -238.8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6659",
    "data-name": "Path 6659",
    d: "M207.935,266.637,206.9,251.505l15-.905,1.035,15.132Z",
    transform: "translate(-206.9 -250.6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6662",
    "data-name": "Path 6662",
    d: "M193.035,266.637,192,251.505l15.132-.905,1.035,15.132Z",
    transform: "translate(-192 -250.6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6665",
    "data-name": "Path 6665",
    d: "M177.835,266.237,176.8,251.105l15-.905,1.035,15.132Z",
    transform: "translate(-176.8 -250.2)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    x: 167.568,
    y: 0,
    width: 98,
    height: 112,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_3",
    x: 397.568,
    y: 2.5,
    width: 98,
    height: 109.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_2",
    x: 282.568,
    y: 2.5,
    width: 98,
    height: 109.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374",
    transform: "translate(120.668 -58.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(-120.668 198.662)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_4_",
    cx: 355.468,
    cy: 205.194,
    rx: 355.468,
    ry: 205.194,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6963",
    "data-name": "Group 6963",
    transform: "translate(0 34)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6701",
    "data-name": "Path 6701",
    d: "M95.083,126.894c1.092,13.833,49.872,5.824,78.995,12.377S210.638,180.4,210.638,180.4",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6702",
    "data-name": "Path 6702",
    d: "M202.473,126.894c-1.092,13.833-49.872,5.824-78.994,12.377S87.5,181.257,87.5,181.257",
    transform: "translate(124)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6703",
    "data-name": "Path 6703",
    d: "M211.064,126.894v55.653",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6885",
    "data-name": "Group 6885",
    transform: "translate(-48.479 173.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860",
    transform: "translate(426.172 178.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M342.752,442.37s-8.381-18.1,1.173-36.039,12.237-22.127,6.2-25.647c-6.035-3.688-8.884,14.248-8.884,14.248s-5.029-12.4-.838-25.311,6.873-34.028,1.173-36.207-1.173,26.317-6.035,36.039c0,0-4.191-10.9-4.861-21.121-.671-10.393.335-26.988-4.191-31.178s-7.375-1.341-3.017,21.624a228.631,228.631,0,0,1,4.358,41.571s-9.89-30-16.427-30.843-6.537,8.884-1.006,17.265c5.7,8.381,16.595,23.635,18.439,31.346,0,0-10.9-22.629-20.618-15.757s8.549,20.618,16.595,25.479,13.745,35.872,13.745,35.872Z",
    transform: "translate(-305.442 -315.533)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M342.752,442.37s-8.381-18.1,1.173-36.039,12.237-22.127,6.2-25.647c-6.035-3.688-8.884,14.248-8.884,14.248s-5.029-12.4-.838-25.311,6.873-34.028,1.173-36.207-1.173,26.317-6.035,36.039c0,0-4.191-10.9-4.861-21.121-.671-10.393.335-26.988-4.191-31.178s-7.375-1.341-3.017,21.624a228.631,228.631,0,0,1,4.358,41.571s-9.89-30-16.427-30.843-6.537,8.884-1.006,17.265c5.7,8.381,16.595,23.635,18.439,31.346,0,0-10.9-22.629-20.618-15.757s8.549,20.618,16.595,25.479,13.745,35.872,13.745,35.872Z",
    transform: "translate(-305.442 -315.533)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M328.388,447.033s8.046-18.271-1.676-35.872c-9.722-17.768-12.572-21.959-6.537-25.647s9.052,14.081,9.052,14.081,5.029-12.4.5-25.311c-4.358-12.907-7.208-33.86-1.509-36.207s1.341,26.15,6.537,35.872c0,0,4.023-10.9,4.694-21.288.5-10.393-.671-26.988,3.855-31.178,4.526-4.358,7.375-1.341,3.185,21.624a234.277,234.277,0,0,0-3.855,41.571S352.19,354.5,358.728,353.5s6.7,8.716,1.173,17.265-16.26,23.8-17.936,31.681c0,0,10.56-22.8,20.283-15.924,9.89,6.705-8.214,20.785-16.26,25.814s-13.242,36.039-13.242,36.039Z",
    transform: "translate(-297.614 -312.654)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859",
    transform: "translate(1.271 121.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M372.915,387.9H306.2l5.364,47.773h55.987Z",
    transform: "translate(-306.2 -387.9)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862",
    transform: "translate(195.09 40.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M227.526,298.922H182.1v-1.509h10.225a2.773,2.773,0,0,0,2.85-2.179l4.526-24.473.838-4.861h15.589l13.913,29.334C231.046,297.078,229.538,298.922,227.526,298.922Z",
    transform: "translate(-157.769 -210.919)",
    fill: "#3a454b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M227.526,298.922H182.1v-1.509h10.225a2.773,2.773,0,0,0,2.85-2.179l4.526-24.473.838-4.861h15.589l13.913,29.334C231.046,297.078,229.538,298.922,227.526,298.922Z",
    transform: "translate(-157.769 -210.919)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M223.4,295.452H188.2a2.773,2.773,0,0,0,2.85-2.179l4.526-24.473h16.26l12.4,25.311A.87.87,0,0,1,223.4,295.452Z",
    transform: "translate(-153.643 -208.958)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M260.9,297.133H170.051a1.283,1.283,0,0,1-1.341-1.509l12.907-61.015a2.013,2.013,0,0,1,2.012-1.509h90.853a1.283,1.283,0,0,1,1.341,1.509l-12.907,61.015A2.012,2.012,0,0,1,260.9,297.133Z",
    transform: "translate(-166.841 -233.1)",
    fill: "#8b9296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M260.9,297.133H170.051a1.283,1.283,0,0,1-1.341-1.509l12.907-61.015a2.013,2.013,0,0,1,2.012-1.509h90.853a1.283,1.283,0,0,1,1.341,1.509l-12.907,61.015A2.012,2.012,0,0,1,260.9,297.133Z",
    transform: "translate(-166.841 -233.1)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M259.8,297.133H168.951a1.283,1.283,0,0,1-1.341-1.509l12.907-61.015a2.013,2.013,0,0,1,2.012-1.509h90.853a1.283,1.283,0,0,1,1.341,1.509l-12.907,61.015A2.013,2.013,0,0,1,259.8,297.133Z",
    transform: "translate(-167.585 -233.1)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M256.93,291.89H170.1L182,235.4h86.83Z",
    transform: "translate(-165.884 -231.545)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863",
    transform: "translate(152.539 119.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M142.2,288.914V287.07l31.346-6.37h61.183a4.15,4.15,0,0,1,4.191,4.191h0a4.15,4.15,0,0,1-4.191,4.191Z",
    transform: "translate(-142.2 -280.7)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M238.852,284.891a4.044,4.044,0,0,1-1.173,2.85,4.374,4.374,0,0,1-2.85,1.173H142.3V287.07l31.346-6.37h61.183A4.116,4.116,0,0,1,238.852,284.891Z",
    transform: "translate(-142.132 -280.7)",
    fill: "#141414",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M216.536,284.891a4.044,4.044,0,0,1-1.173,2.85,4.374,4.374,0,0,1-2.85,1.173H175.3V287.07l31.346-6.37h5.867A4.116,4.116,0,0,1,216.536,284.891Z",
    transform: "translate(-119.816 -280.7)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6870",
    "data-name": "Group 6870",
    transform: "translate(116.499 128.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864",
    transform: "translate(155.053 9.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M213.2,500.864h8.381L236.667,291.5H225.437Z",
    transform: "translate(-213.2 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M213.2,500.728h8.381l14.248-198.971.838-10.057H225.437l-.5,10.057Z",
    transform: "translate(-213.2 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M220.2,301.255h10.9l.838-9.555H220.7Z",
    transform: "translate(-208.466 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6865",
    "data-name": "Group 6865",
    transform: "translate(92.194 9.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M177.209,500.864h8.214L186.931,291.5H175.7Z",
    transform: "translate(-175.7 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M175.7,291.7l.335,33.693,1.006,175.336h8.381L186.6,325.393l.335-33.693Z",
    transform: "translate(-175.7 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M175.7,291.7l.335,34.2H186.6l.335-34.2Z",
    transform: "translate(-175.7 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6866",
    "data-name": "Group 6866",
    transform: "translate(4.694 9.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M123.5,500.864h8.381L146.967,291.5H135.9Z",
    transform: "translate(-123.5 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M123.5,500.728h8.381L146.3,301.758l.671-10.057H135.9l-.67,10.057Z",
    transform: "translate(-123.5 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M130.5,301.255h11.063l.67-9.555H131.171Z",
    transform: "translate(-118.766 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6867",
    "data-name": "Group 6867",
    transform: "translate(235.848 9.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M276.319,500.864H284.7L272.463,291.5H261.4Z",
    transform: "translate(-261.4 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    d: "M261.4,291.7l.67,10.057,14.248,198.971H284.7L273.134,301.758l-.67-10.057Z",
    transform: "translate(-261.4 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6592",
    "data-name": "Path 6592",
    d: "M272.463,291.7H261.4l.67,9.555h11.063Z",
    transform: "translate(-261.4 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6868",
    "data-name": "Group 6868",
    transform: "translate(8.214 4.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M129.288,298.86H369.494a3.721,3.721,0,0,0,3.688-3.688V288.3H125.6v6.873A3.721,3.721,0,0,0,129.288,298.86Z",
    transform: "translate(-125.6 -288.3)",
    fill: "#40474c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M129.288,298.86H369.494a3.721,3.721,0,0,0,3.688-3.688V288.3H125.6v6.873A3.721,3.721,0,0,0,129.288,298.86Z",
    transform: "translate(-125.6 -288.3)",
    fill: "#fff",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6410",
    "data-name": "Rectangle 6410",
    width: 247.414,
    height: 5.196,
    transform: "translate(255.732 9.931) rotate(180)",
    fill: "#31373c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6869",
    "data-name": "Group 6869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    d: "M123.717,291.635H381.524a3,3,0,0,0,3.017-3.017h0a3,3,0,0,0-3.017-3.017H123.717a3,3,0,0,0-3.017,3.017h0A3.116,3.116,0,0,0,123.717,291.635Z",
    transform: "translate(-120.7 -285.6)",
    fill: "#3a454b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__1_",
    transform: "translate(59.042 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M134.2,279.19l11.734,1.676a39.7,39.7,0,0,1,8.214-1.676,47.883,47.883,0,0,1,9.052,0s5.364,2.012,5.364,7.04c0,0-12.4,3.352-17.1,1.341l-17.1-1.341v-7.04Z",
    transform: "translate(-54.113 -161.929)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    d: "M134.2,279.19l11.734,1.676a39.7,39.7,0,0,1,8.214-1.676,47.883,47.883,0,0,1,9.052,0s5.364,2.012,5.364,7.04c0,0-12.4,3.352-17.1,1.341l-17.1-1.341v-7.04Z",
    transform: "translate(-54.113 -161.929)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6872",
    "data-name": "Group 6872",
    transform: "translate(59.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6871",
    "data-name": "Group 6871",
    transform: "translate(46.6 29.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M152.582,231.8a34.071,34.071,0,0,0,1.341,7.04,3.7,3.7,0,0,1-4.023,0Z",
    transform: "translate(-149.9 -222.953)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M155.234,230.777c-.5,1.006-1.173,1.844-1.844,1.509-.5-.168-.67-1.341-.168-2.347s1.173-1.844,1.844-1.509C155.569,228.766,155.569,229.771,155.234,230.777Z",
    transform: "translate(-147.859 -225.282)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M158.537,227.659s-3.52-2.179-6.537-.5",
    transform: "translate(-148.48 -226.522)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.725
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    d: "M161.25,253.357a9.581,9.581,0,0,1-1.173,1.341,17.5,17.5,0,0,1-8.716,4.861,12.941,12.941,0,0,1-2.514.335,14.91,14.91,0,0,1-12.069-4.861,16.015,16.015,0,0,1-3.185-5.2c-3.017-8.046,0-14.416,4.358-25.479a17.56,17.56,0,0,1,4.191-6.37,16.254,16.254,0,0,1,23.132.838C173.821,227.878,167.955,244.64,161.25,253.357Z",
    transform: "translate(-115.153 -206.162)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6602",
    "data-name": "Path 6602",
    d: "M149.583,243.876a12.939,12.939,0,0,1-2.514.335A14.91,14.91,0,0,1,135,239.35a20.652,20.652,0,0,1,3.688-2.85A24.327,24.327,0,0,1,149.583,243.876Z",
    transform: "translate(-113.376 -190.647)",
    fill: "#ff9a6c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    d: "M122.1,252.629c1.173,7.878,18.271,10.728,18.271,10.728s8.549,3.855,8.884.5c-3.52-4.023-3.855-7.543-2.682-10.728a14.446,14.446,0,0,1,3.52-5.029c.838-.838,1.676-1.509,2.514-2.347l-5.2-21.456C143.556,232.514,130.649,251.455,122.1,252.629Z",
    transform: "translate(-122.1 -198.897)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M166.793,215.607s3.688-.5,6.537,6.37c2.347,5.7-3.185,7.04-3.017,13.075.168,6.2-5.364,9.555-5.364,9.555s-4.693,4.023-8.716,1.844c0,0-5.2,2.514-6.537,7.04s-9.555-3.688-16.763-2.347c0,0-4.861-4.694-4.526-15.757a37.611,37.611,0,0,1,3.52-14.081s2.179-6.7,10.393-10.393C150.7,207.058,165.284,209.908,166.793,215.607Z",
    transform: "translate(-117.846 -209.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    "data-name": "Path 6605",
    d: "M144.567,231.722a7.625,7.625,0,0,0,1.509,6.537c1.844,2.012,4.693-.5,5.867-3.855,1.006-3.017,1.341-7.711-1.341-8.381C147.92,225.519,145.07,228.537,144.567,231.722Z",
    transform: "translate(-107.019 -197.77)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6873",
    "data-name": "Group 6873",
    transform: "translate(11.361 52.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6606",
    "data-name": "Path 6606",
    d: "M181.035,247.993c-2.347,6.7-4.526,13.075-6.37,19.277-1.173,3.855-2.347,7.543-3.352,11.231-.838,3.017-1.676,6.035-2.347,8.884l-1.006,4.023q-2.766,11.063-4.526,20.115a266.206,266.206,0,0,0-4.358,28.329L93.2,331.638c2.347-11.231,4.023-21.121,6.537-31.849,1.341-5.867,3.017-11.9,5.029-18.606,1.341-4.861,3.017-9.89,5.029-15.421,3.185-9.052,6.2-15.086,8.549-18.774a13.364,13.364,0,0,1,10.225-6.2C152.707,239.109,181.035,247.993,181.035,247.993Z",
    transform: "translate(-93.2 -240.574)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    d: "M158.6,279.89l11.734,1.676a39.7,39.7,0,0,1,8.214-1.676,47.889,47.889,0,0,1,9.052,0s5.364,2.012,5.364,7.04c0,0-12.4,3.353-17.1,1.341l-17.1-1.341v-7.04Z",
    transform: "translate(-37.613 -161.455)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6874",
    "data-name": "Group 6874",
    transform: "translate(48.406 307.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6608",
    "data-name": "Path 6608",
    d: "M115.3,420.461l12.237.168,6.035-28.161-12.237-.168Z",
    transform: "translate(-115.3 -392.3)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6609",
    "data-name": "Path 6609",
    d: "M120.253,392.3l12.237.168-3.52,16.092-12.069-.838Z",
    transform: "translate(-114.218 -392.3)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6610",
    "data-name": "Path 6610",
    d: "M161.049,407.528a384.955,384.955,0,0,1-17.768,52.634l-22.294-1.676s9.219-35.872,12.572-68.559c2.011-20.283,1.844-37.045-4.023-38.386-3.688-.838-12.4-.838-23.635-.5V309.3c31.346,6.37,62.692,18.606,65.038,28.329C173.956,351.374,168.089,380.373,161.049,407.528Z",
    transform: "translate(-73.251 -141.416)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6875",
    "data-name": "Group 6875",
    transform: "translate(45.221 307.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6611",
    "data-name": "Path 6611",
    d: "M113.4,403.363l26.485,1.676,4.023-11.4L114.573,392.3Z",
    transform: "translate(-113.4 -392.3)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6612",
    "data-name": "Path 6612",
    d: "M113.4,403.363l26.485,1.676,4.023-11.4L114.573,392.3Z",
    transform: "translate(-113.4 -392.3)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6876",
    "data-name": "Group 6876",
    transform: "translate(62.486 329.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6613",
    "data-name": "Path 6613",
    d: "M123.7,410.929h.335l.335.168v.168h.168a21.558,21.558,0,0,0,3.185.671,2.909,2.909,0,0,0,2.347-.5,1.352,1.352,0,0,0,.5-1.509,1.114,1.114,0,0,0-.67-.838c-.838-.335-2.179.168-3.353.671a3.76,3.76,0,0,0,1.173-2.85c0-.5-.5-.838-1.006-1.006a1.806,1.806,0,0,0-1.341.335c-1.509,1.006-1.676,4.358-1.676,4.693Zm1.341-.67a.164.164,0,0,0-.168.168c0-1.173.335-3.017,1.006-3.688.168-.168.335-.168.671-.168h.168a.535.535,0,0,1,.5.5A11.893,11.893,0,0,1,125.041,410.258Zm.168.5c1.509-.838,3.52-1.676,4.358-1.341a.361.361,0,0,1,.335.335c.168.335,0,.67-.335,1.006C128.9,411.432,127.388,411.432,125.209,410.761Z",
    transform: "translate(-123.7 -405.9)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6614",
    "data-name": "Path 6614",
    d: "M129.992,408.338l-13.745-.838a1.062,1.062,0,0,0-1.006.838h0l-1.341,10.9a2.35,2.35,0,0,0,2.012,2.347c4.861.168,7.04.168,13.075.335,3.688.168,11.063,1.006,16.092.5s4.526-5.532,2.347-5.7c-5.2-.671-12.237-4.526-15.421-7.375A2.39,2.39,0,0,0,129.992,408.338Z",
    transform: "translate(-67.841 -75.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    "data-name": "Path 6615",
    d: "M161.116,407.528c-8.381-5.364-18.1-11.566-27.658-17.6,2.012-20.283,1.844-37.045-4.023-38.386-3.688-.838-12.4-.838-23.635-.5V309.3c31.346,6.37,62.692,18.606,65.038,28.329C174.023,351.374,168.156,380.373,161.116,407.528Z",
    transform: "translate(-73.319 -141.416)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6877",
    "data-name": "Group 6877",
    transform: "translate(119.981 307.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6616",
    "data-name": "Path 6616",
    d: "M158,420.461l12.237.168,6.2-28.161L164.2,392.3Z",
    transform: "translate(-158 -392.3)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    "data-name": "Path 6617",
    d: "M163.12,392.3l12.237.168-3.52,16.092-12.237-.838Z",
    transform: "translate(-156.918 -392.3)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6618",
    "data-name": "Path 6618",
    d: "M161.984,317.417,164,301.66,99.962,291.1s-20.953,41.4-10.728,61.854c9.387,18.606,109.459,7.543,124.881,10.9,15.589,3.353-8.381,106.945-8.381,106.945l22.294,1.676s34.531-93.2,27.49-122.534C252.333,337.2,199.531,320.267,161.984,317.417Z",
    transform: "translate(-86.423 -153.723)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6878",
    "data-name": "Group 6878",
    transform: "translate(116.797 307.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    "data-name": "Path 6619",
    d: "M156.1,403.363l26.652,1.676,3.855-11.4L157.273,392.3Z",
    transform: "translate(-156.1 -392.3)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6620",
    "data-name": "Path 6620",
    d: "M156.1,403.363l26.652,1.676,3.855-11.4L157.273,392.3Z",
    transform: "translate(-156.1 -392.3)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6879",
    "data-name": "Group 6879",
    transform: "translate(134.062 329.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6621",
    "data-name": "Path 6621",
    d: "M166.4,410.929h.335l.335.168v.168h.168a21.559,21.559,0,0,0,3.185.671,2.909,2.909,0,0,0,2.347-.5,1.352,1.352,0,0,0,.5-1.509,1.114,1.114,0,0,0-.671-.838c-.838-.335-2.179.168-3.352.671a3.76,3.76,0,0,0,1.173-2.85c0-.5-.5-.838-1.006-1.006a1.806,1.806,0,0,0-1.341.335c-1.509,1.006-1.676,4.358-1.676,4.693Zm1.341-.67a.164.164,0,0,0-.168.168c0-1.173.335-3.017,1.006-3.688.168-.168.335-.168.671-.168h.168a.535.535,0,0,1,.5.5A8.868,8.868,0,0,1,167.741,410.258Zm.168.5c1.509-.838,3.52-1.676,4.358-1.341a.361.361,0,0,1,.335.335c.168.335,0,.67-.335,1.006C171.764,411.432,170.088,411.432,167.909,410.761Z",
    transform: "translate(-166.4 -405.9)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6622",
    "data-name": "Path 6622",
    d: "M172.692,408.338l-13.745-.838a1.062,1.062,0,0,0-1.006.838h0l-1.341,10.9a2.35,2.35,0,0,0,2.012,2.347c4.861.168,7.04.168,13.075.335,3.688.168,11.063,1.006,16.092.5s4.526-5.532,2.347-5.7c-5.2-.671-12.237-4.526-15.422-7.375A2.389,2.389,0,0,0,172.692,408.338Z",
    transform: "translate(-38.965 -75.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6880",
    "data-name": "Group 6880",
    transform: "translate(11.193 139.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    "data-name": "Path 6623",
    d: "M93.1,297.361l29.67,3.855.838-4.358L93.938,292.5Z",
    transform: "translate(-93.1 -292.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    "data-name": "Path 6624",
    d: "M112.935,295.1l-.335,4.358,27.323,3.855v-4.358Z",
    transform: "translate(-79.913 -290.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    d: "M129.9,297.5v4.191l4.023.5v-4.023Z",
    transform: "translate(-68.214 -289.119)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6626",
    "data-name": "Path 6626",
    d: "M144.241,258.326c-1.173,3.855-2.347,7.543-3.352,11.231-.838,3.017-1.676,6.035-2.347,8.884-2.012-11.231,1.676-24.641,1.676-24.641Z",
    transform: "translate(-51.583 -178.948)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    d: "M149.117,245c5.364,1.006,7.04,42.577,7.376,47.1.168,4.358,26.317,13.075,26.317,13.075v6.035s-27.826-2.011-34.363-4.693-8.046-41.236-8.046-41.236Z",
    transform: "translate(-49.921 -184.899)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    "data-name": "Path 6628",
    d: "M150.368,245c4.861,1.509,7.376,29,7.376,29l-15.254,6.035L138.8,264.78s-1.006-3.017,1.006-9.555C142.824,245.838,150.368,245,150.368,245Z",
    transform: "translate(-51.172 -184.899)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6884",
    "data-name": "Group 6884",
    transform: "translate(0 46.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    "data-name": "Path 6629",
    d: "M217.61,346.883H70.1v-7.04A13.164,13.164,0,0,1,83.342,326.6H204.368a13.164,13.164,0,0,1,13.242,13.242v7.04Z",
    transform: "translate(-38.419 -176.24)",
    fill: "#555d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    "data-name": "Path 6630",
    d: "M101.5,296.5h81.3a6.591,6.591,0,0,1,6.37,8.046l-14.583,62.859h-3.352l12.4-54.981a6.52,6.52,0,0,0-6.37-7.878h-74.09Z",
    transform: "translate(-17.185 -196.596)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    d: "M127.509,340v52.97a3,3,0,0,1-3.017,3.017H111.417a3,3,0,0,1-3.017-3.017V340Z",
    transform: "translate(-12.519 -167.179)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6883",
    "data-name": "Group 6883",
    transform: "translate(31.849 289.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6881",
    "data-name": "Group 6881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M81.6,415.4a5.7,5.7,0,1,0-5.7,5.7A5.873,5.873,0,0,0,81.6,415.4Z",
    transform: "translate(-70.2 -409.7)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    d: "M77.6,414.25a2.85,2.85,0,1,0-2.85,2.85A2.937,2.937,0,0,0,77.6,414.25Z",
    transform: "translate(-69.05 -408.55)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6882",
    "data-name": "Group 6882",
    transform: "translate(135.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M162.5,415.4a5.7,5.7,0,1,0-5.7,5.7A5.873,5.873,0,0,0,162.5,415.4Z",
    transform: "translate(-151.1 -409.7)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M158.6,414.25a2.85,2.85,0,1,0-2.85,2.85A3.063,3.063,0,0,0,158.6,414.25Z",
    transform: "translate(-149.883 -408.55)",
    fill: "#fff",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M146.384,422.78V362.1H137v60.68c-36.375,1.006-58.333,13.578-62.859,16.427a1.761,1.761,0,0,0-.838,1.509v5.029a1.86,1.86,0,0,0,1.844,1.844h0a1.76,1.76,0,0,0,1.509-.838l2.179-3.855A203.822,203.822,0,0,1,137,433.341v9.89a2.292,2.292,0,0,0,2.347,2.347h4.694a2.292,2.292,0,0,0,2.347-2.347v-9.89A203.82,203.82,0,0,1,204.55,442.9l2.179,3.855a1.76,1.76,0,0,0,1.509.838h0a1.86,1.86,0,0,0,1.844-1.844v-5.029a1.76,1.76,0,0,0-.838-1.509C204.718,436.358,182.591,423.786,146.384,422.78Z",
    transform: "translate(-36.255 -152.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6411",
    "data-name": "Rectangle 6411",
    width: 6.202,
    height: 11.231,
    transform: "translate(102.419 289.656)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6412",
    "data-name": "Rectangle 6412",
    width: 19.109,
    height: 21.959,
    transform: "translate(95.881 172.821)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M223.256,337.985v6.37a3.183,3.183,0,0,1-3.185,3.185H70.885a3.183,3.183,0,0,1-3.185-3.185v-6.37a3.183,3.183,0,0,1,3.185-3.185H220.071A3.183,3.183,0,0,1,223.256,337.985Z",
    transform: "translate(-40.042 -170.695)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M165.855,407.542h-87S51.2,361.613,51.2,285.511V257.686A20.89,20.89,0,0,1,71.985,236.9h36.877a20.757,20.757,0,0,1,20.785,20.115C130.654,296.072,136.521,380.89,165.855,407.542Z",
    transform: "translate(-51.2 -236.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    d: "M146.746,407.542H82.713a6.578,6.578,0,0,1-5.867-3.52C70.477,391.953,51.2,349.209,51.2,285.511V257.686A20.782,20.782,0,0,1,71.985,236.9h31.849a20.757,20.757,0,0,1,20.785,20.115c1.006,35.034,5.7,106.442,27.658,140.135A6.736,6.736,0,0,1,146.746,407.542Z",
    transform: "translate(-51.2 -236.9)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    "data-name": "Path 6640",
    d: "M190.525,337.985v6.37a3.183,3.183,0,0,1-3.185,3.185H120.458a4.438,4.438,0,0,1-4.358-4.358v-4.023a4.438,4.438,0,0,1,4.358-4.358h66.882A3.183,3.183,0,0,1,190.525,337.985Z",
    transform: "translate(-7.311 -170.695)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6892",
    "data-name": "Group 6892",
    transform: "matrix(1, 0.017, -0.017, 1, 166.283, 223.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6891",
    "data-name": "Group 6891",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6890",
    "data-name": "Group 6890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6889",
    "data-name": "Group 6889",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6888",
    "data-name": "Group 6888",
    transform: "translate(0 0.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6887",
    "data-name": "Group 6887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6886",
    "data-name": "Group 6886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    d: "M181.956,245.76v-2.333h1.436c.718,0,1.077.359,1.077,1.256a1.227,1.227,0,0,1-1.256,1.256l-1.256-.179m0-3.23v-2.153h1.256a1.345,1.345,0,0,1,.9.179,1.055,1.055,0,0,1,.359.9.932.932,0,0,1-.359.718,1.371,1.371,0,0,1-.9.359h-1.256m1.436-3.23h-2.512l-.179,7.537h2.692a3.224,3.224,0,0,0,1.974-.538,2.275,2.275,0,0,0,.718-1.615,1.319,1.319,0,0,0-.359-1.077,1.792,1.792,0,0,0-.9-.718,1.4,1.4,0,0,0,.718-.718c.179-.359.359-.538.359-.9a2.193,2.193,0,0,0-.538-1.615,6.449,6.449,0,0,0-1.974-.359",
    transform: "translate(-180.7 -238.582)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    "data-name": "Path 6642",
    d: "M185.636,239h-1.256l-.179,8.075h1.256l.179-8.075",
    transform: "translate(-177.919 -238.821)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    d: "M187.933,245.145a.987.987,0,0,1-.9-.538,3.051,3.051,0,0,1,0-2.871,1.017,1.017,0,0,1,1.795,0,3.051,3.051,0,0,1,0,2.871.987.987,0,0,1-.9.538m.179-4.845a2.594,2.594,0,0,0-1.256.359,1.838,1.838,0,0,0-.9,1.077,4.223,4.223,0,0,0-.359,1.436h0a3.827,3.827,0,0,0,.538,2.153,2.081,2.081,0,0,0,1.795.718,2.594,2.594,0,0,0,1.256-.359,1.838,1.838,0,0,0,.9-1.077,4.223,4.223,0,0,0,.359-1.436v-.359a2.451,2.451,0,0,0-.718-1.974,2.194,2.194,0,0,0-1.615-.538",
    transform: "translate(-176.807 -237.788)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    "data-name": "Path 6644",
    d: "M191.312,240.3a2.081,2.081,0,0,0-1.795.718,2.7,2.7,0,0,0-.718,1.974v.179a3.827,3.827,0,0,0,.538,2.153,2.081,2.081,0,0,0,1.795.718,2.551,2.551,0,0,0,1.077-.359,3.151,3.151,0,0,0,.9-.718,3.031,3.031,0,0,0,.359-.9h-1.077a1.143,1.143,0,0,1-1.974.718,2.78,2.78,0,0,1-.359-1.436v-.18a3.381,3.381,0,0,1,.359-1.436.987.987,0,0,1,.9-.538.932.932,0,0,1,.718.359,1.361,1.361,0,0,1,.359.718h1.077a2.505,2.505,0,0,0-.538-1.615,5.241,5.241,0,0,0-1.615-.359",
    transform: "translate(-174.264 -237.788)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M193.236,239h-1.077l-.359,8.075h1.256V245.1l.538-.538,1.615,2.512h1.436l-2.153-3.41,1.974-2.333H195.03l-1.436,1.795-.359.538V239",
    transform: "translate(-171.881 -238.821)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M195.956,242.712a2.551,2.551,0,0,1,.359-1.077,1.371,1.371,0,0,1,.9-.359.932.932,0,0,1,.718.359,1.37,1.37,0,0,1,.359.9v.18h-2.333m1.256-2.512a2.594,2.594,0,0,0-1.256.359,1.838,1.838,0,0,0-.9,1.077,4.222,4.222,0,0,0-.359,1.436v.179a2.451,2.451,0,0,0,.718,1.974,2.3,2.3,0,0,0,1.795.718,3.327,3.327,0,0,0,1.256-.359,3.918,3.918,0,0,0,.9-.718l-.718-.718a1.632,1.632,0,0,1-1.436.718,1.371,1.371,0,0,1-.9-.359,2.55,2.55,0,0,1-.359-1.077h3.589v-.538a3.827,3.827,0,0,0-.538-2.153,5.265,5.265,0,0,0-1.794-.538",
    transform: "translate(-169.577 -237.867)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    d: "M200.212,246.078a.987.987,0,0,1-.9-.538,3.051,3.051,0,0,1,0-2.871,1.1,1.1,0,0,1,1.974.179v2.512a1.3,1.3,0,0,1-1.077.718m2.512-7.178h-1.256v2.871a1.766,1.766,0,0,0-1.436-.538,1.885,1.885,0,0,0-1.615.9,6.054,6.054,0,0,0-.718,2.153,3.827,3.827,0,0,0,.538,2.153,1.795,1.795,0,0,0,2.871,0v.538h1.077l.538-8.075",
    transform: "translate(-167.193 -238.9)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    "data-name": "Path 6648",
    d: "M208.581,239.2h-1.256l-1.974,5.922-1.795-5.922H202.3l2.333,7.537h1.256l2.692-7.537",
    transform: "translate(-163.538 -238.662)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    "data-name": "Path 6649",
    d: "M207.536,241.153h-1.256L206.1,246.9h1.256l.179-5.742M207,239a.634.634,0,1,0,.538.179c-.18,0-.359-.179-.538-.179",
    transform: "translate(-160.519 -238.821)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    "data-name": "Path 6650",
    d: "M209.753,240.2a2.038,2.038,0,0,0-1.436.538,1.629,1.629,0,0,0-.538,1.256,1.349,1.349,0,0,0,.9,1.256,7.468,7.468,0,0,0,1.077.359,1.371,1.371,0,0,1,.9.359.659.659,0,0,1,.179.538c0,.18-.179.359-.179.538-.179.179-.359.179-.718.179s-.538,0-.718-.179a.932.932,0,0,1-.359-.718H207.6a1.345,1.345,0,0,0,.179.9,1.4,1.4,0,0,0,.718.718,2.661,2.661,0,0,0,1.256.179,2.194,2.194,0,0,0,1.615-.538,1.816,1.816,0,0,0,.718-1.256c0-.359,0-.538-.179-.718l-.538-.538a1.924,1.924,0,0,0-1.077-.359c-.538-.18-.718-.18-.9-.359s-.18-.179-.18-.359.18-.359.359-.538.359-.179.718-.179.538,0,.718.179a.659.659,0,0,1,.179.538h1.256a1.629,1.629,0,0,0-.538-1.256,7.27,7.27,0,0,0-2.153-.538",
    transform: "translate(-159.327 -237.867)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    d: "M211.936,241.153h-1.256L210.5,246.9h1.256l.179-5.742M211.4,239a.635.635,0,1,0,.538.179A.659.659,0,0,0,211.4,239",
    transform: "translate(-157.023 -238.821)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    "data-name": "Path 6652",
    d: "M213.853,239.4H212.6v1.436h-.9v.9h.9l-.179,3.23c0,1.077.359,1.615,1.256,1.615a1.079,1.079,0,0,0,.718-.179v-.9h-.359c-.179,0-.359,0-.359-.179s-.179-.179-.179-.538l.179-3.23h.9v-.9h-.9l.18-1.256",
    transform: "translate(-156.07 -238.503)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6653",
    "data-name": "Path 6653",
    d: "M216.133,244.945a.987.987,0,0,1-.9-.538,3.051,3.051,0,0,1,0-2.871,1.017,1.017,0,0,1,1.794,0,3.051,3.051,0,0,1,0,2.871.987.987,0,0,1-.9.538m.179-4.845a2.594,2.594,0,0,0-1.256.359,1.838,1.838,0,0,0-.9,1.077,4.224,4.224,0,0,0-.359,1.436h0a3.827,3.827,0,0,0,.538,2.153,2.081,2.081,0,0,0,1.795.718,2.594,2.594,0,0,0,1.256-.359,1.838,1.838,0,0,0,.9-1.077,4.222,4.222,0,0,0,.359-1.436v-.359a2.451,2.451,0,0,0-.718-1.974,3.406,3.406,0,0,0-1.615-.538",
    transform: "translate(-154.401 -237.947)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6654",
    "data-name": "Path 6654",
    d: "M219.612,240.1a1.355,1.355,0,0,0-1.256.718v-.538h-1.077l-.179,5.742h1.256l.179-3.948a.984.984,0,0,1,1.077-.718h.538V240.1h-.538",
    transform: "translate(-151.779 -237.947)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    d: "M221.253,240.1a2.038,2.038,0,0,0-1.436.538,1.629,1.629,0,0,0-.538,1.256,1.349,1.349,0,0,0,.9,1.256,7.486,7.486,0,0,0,1.077.359,1.371,1.371,0,0,1,.9.359.659.659,0,0,1,.179.538c0,.179-.179.359-.179.538-.179.179-.359.179-.718.179s-.538,0-.718-.179a.932.932,0,0,1-.359-.718H219.1a1.345,1.345,0,0,0,.179.9,1.4,1.4,0,0,0,.718.718,2.66,2.66,0,0,0,1.256.18,2.194,2.194,0,0,0,1.615-.538,1.816,1.816,0,0,0,.718-1.256c0-.359,0-.538-.179-.718l-.538-.538a1.924,1.924,0,0,0-1.077-.359c-.538-.179-.718-.179-.9-.359s-.179-.179-.179-.359.179-.359.359-.538.359-.179.718-.179.538,0,.718.179a.659.659,0,0,1,.179.538h1.256a1.629,1.629,0,0,0-.538-1.256,7.27,7.27,0,0,0-2.153-.538",
    transform: "translate(-150.19 -237.947)",
    fill: "#242424"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6901",
    "data-name": "Group 6901",
    transform: "translate(209.852 242.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6899",
    "data-name": "Group 6899",
    transform: "translate(0 0.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6898",
    "data-name": "Group 6898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6897",
    "data-name": "Group 6897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6896",
    "data-name": "Group 6896",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6895",
    "data-name": "Group 6895",
    transform: "translate(0.502 0.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6894",
    "data-name": "Group 6894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6893",
    "data-name": "Group 6893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M212.477,262.285a.556.556,0,0,1-.517-.517v-.517c-.129-1.423,1.94-2.2,1.94-2.2v-.517c-.517-.259-.517-.776-.647-2.069a1.482,1.482,0,0,1,1.293-1.681h.129a1.665,1.665,0,0,1,1.681,1.423v.129c0,1.293,0,1.811-.388,2.069-.129.129,0,.388,0,.517,0,0,2.069.647,2.2,1.94v.517a.474.474,0,0,1-.517.517l-5.173.388m1.811-11.381a7.527,7.527,0,0,0-6.984,8.019,7.63,7.63,0,0,0,8.019,7.113,7.527,7.527,0,0,0,6.984-8.019,7.63,7.63,0,0,0-8.019-7.113",
    transform: "translate(-207.288 -250.889)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6658",
    "data-name": "Path 6658",
    d: "M213.517,253.9h-.129a1.482,1.482,0,0,0-1.293,1.681c.129,1.293.259,1.811.647,2.069a.393.393,0,0,1,0,.517s-2.069.776-1.94,2.2v.517a.556.556,0,0,0,.517.517l5.173-.259a.556.556,0,0,0,.517-.517v-.517c-.129-1.423-2.2-1.94-2.2-1.94a.393.393,0,0,1,0-.517c.388-.388.388-.905.388-2.069v-.129a1.785,1.785,0,0,0-1.681-1.552",
    transform: "translate(-206.26 -250.006)",
    fill: "#909090"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6900",
    "data-name": "Group 6900",
    transform: "translate(10.218 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2968",
    "data-name": "Ellipse 2968",
    cx: 3.104,
    cy: 3.104,
    rx: 3.104,
    ry: 3.104,
    fill: "#e3393c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M2.531,2.983a.322.322,0,0,1-.234-.1L-.161.3A.323.323,0,0,1,.308-.149L2.765,2.437a.323.323,0,0,1-.234.546Z",
    transform: "translate(1.867 1.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M.073,2.725a.323.323,0,0,1-.222-.558L2.308-.161a.323.323,0,1,1,.445.469L.3,2.636A.322.322,0,0,1,.073,2.725Z",
    transform: "translate(1.867 1.737)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6910",
    "data-name": "Group 6910",
    transform: "translate(190.58 242.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908",
    transform: "translate(0 0.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6907",
    "data-name": "Group 6907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6906",
    "data-name": "Group 6906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6905",
    "data-name": "Group 6905",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6904",
    "data-name": "Group 6904",
    transform: "translate(0.502 0.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6903",
    "data-name": "Group 6903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6902",
    "data-name": "Group 6902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6660",
    "data-name": "Path 6660",
    d: "M197.577,262.285a.556.556,0,0,1-.517-.517v-.517c-.129-1.423,1.94-2.2,1.94-2.2v-.517c-.517-.259-.517-.776-.647-2.069a1.482,1.482,0,0,1,1.293-1.681h.129a1.665,1.665,0,0,1,1.681,1.423v.129c0,1.293,0,1.811-.388,2.069v.517s2.069.647,2.2,1.94v.517a.474.474,0,0,1-.517.517l-5.173.388m1.811-11.381a7.527,7.527,0,0,0-6.984,8.019,7.63,7.63,0,0,0,8.019,7.113,7.527,7.527,0,0,0,6.984-8.019,7.63,7.63,0,0,0-8.019-7.113",
    transform: "translate(-192.388 -250.889)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6661",
    "data-name": "Path 6661",
    d: "M198.717,253.9h-.129a1.482,1.482,0,0,0-1.293,1.681c.129,1.293.259,1.811.647,2.069a.393.393,0,0,1,0,.517s-2.069.776-1.94,2.2v.517a.556.556,0,0,0,.517.517l5.173-.259a.556.556,0,0,0,.517-.517v-.517c-.129-1.423-2.2-1.94-2.2-1.94a.393.393,0,0,1,0-.517c.388-.388.388-.905.388-2.069v-.129a1.785,1.785,0,0,0-1.681-1.552",
    transform: "translate(-191.33 -250.006)",
    fill: "#909090"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6909",
    "data-name": "Group 6909",
    transform: "translate(10.347 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2969",
    "data-name": "Ellipse 2969",
    cx: 3.104,
    cy: 3.104,
    rx: 3.104,
    ry: 3.104,
    fill: "#e3393c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M2.531,2.983a.322.322,0,0,1-.234-.1L-.161.3A.323.323,0,0,1,.308-.149L2.765,2.437a.323.323,0,0,1-.234.546Z",
    transform: "translate(1.867 1.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M.073,2.725a.323.323,0,0,1-.216-.564L2.444-.167a.323.323,0,1,1,.433.481L.29,2.642A.322.322,0,0,1,.073,2.725Z",
    transform: "translate(1.737 1.737)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6919",
    "data-name": "Group 6919",
    transform: "translate(170.922 242.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6917",
    "data-name": "Group 6917",
    transform: "translate(0 0.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6916",
    "data-name": "Group 6916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6915",
    "data-name": "Group 6915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6914",
    "data-name": "Group 6914",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6913",
    "data-name": "Group 6913",
    transform: "translate(0.502 0.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6912",
    "data-name": "Group 6912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6911",
    "data-name": "Group 6911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6663",
    "data-name": "Path 6663",
    d: "M182.377,261.985a.556.556,0,0,1-.517-.517v-.517c-.129-1.423,1.94-2.2,1.94-2.2v-.517c-.517-.259-.517-.776-.647-2.069a1.557,1.557,0,0,1,1.293-1.681h.129a1.463,1.463,0,0,1,1.552,1.423v.129c0,1.293,0,1.811-.388,2.069-.129.129,0,.388,0,.517,0,0,2.069.647,2.2,1.94v.517a.474.474,0,0,1-.517.517l-5.044.388m1.811-11.381a7.527,7.527,0,0,0-6.984,8.019,7.63,7.63,0,0,0,8.019,7.113,7.584,7.584,0,0,0-1.035-15.132",
    transform: "translate(-177.188 -250.588)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6664",
    "data-name": "Path 6664",
    d: "M183.517,253.6h-.129a1.482,1.482,0,0,0-1.293,1.681c.129,1.293.259,1.811.647,2.069a.393.393,0,0,1,0,.517s-2.069.776-1.94,2.2v.517a.556.556,0,0,0,.517.517l5.173-.259a.556.556,0,0,0,.517-.517v-.517c-.129-1.423-2.2-1.94-2.2-1.94a.393.393,0,0,1,0-.517c.388-.388.388-.905.388-2.069v-.129c-.259-1.035-.905-1.681-1.681-1.552",
    transform: "translate(-176.13 -249.709)",
    fill: "#909090"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6918",
    "data-name": "Group 6918",
    transform: "translate(10.347 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2970",
    "data-name": "Ellipse 2970",
    cx: 3.104,
    cy: 3.104,
    rx: 3.104,
    ry: 3.104,
    fill: "#e3393c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M2.4,2.854a.322.322,0,0,1-.235-.1L-.161.3A.323.323,0,0,1,.308-.149L2.636,2.308a.323.323,0,0,1-.235.546Z",
    transform: "translate(1.867 1.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    d: "M.073,2.854A.323.323,0,0,1-.149,2.3L2.437-.161a.323.323,0,1,1,.445.469L.3,2.765A.322.322,0,0,1,.073,2.854Z",
    transform: "translate(1.737 1.608)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6936",
    "data-name": "Group 6936",
    transform: "translate(-38 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -82.67, 104.9)",
    filter: "url(#Union_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M5843.151,2969.872a40,40,0,1,1,16.513.333L5851.5,2984.9Z",
    transform: "translate(-5635.63 -2884.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972",
    "data-name": "Ellipse 2972",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(156.5 111)",
    fill: "#f17072"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 10.7,
    y2: 11.2,
    transform: "translate(167.1 121.4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 10.6,
    x2: 11.2,
    transform: "translate(166.9 121.7)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6935",
    "data-name": "Group 6935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6922",
    "data-name": "Group 6922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6921",
    "data-name": "Group 6921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6920",
    "data-name": "Group 6920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6666",
    "data-name": "Path 6666",
    d: "M139.9,121.5s5.4,3,3.7,10.3-2.4,8.3-1,11.3,2.6,15.4,1.1,17.6c-1.5,2.3-16.6-11.1-18.3-21.8s2.1-15.2,3.4-16.9C130.3,120.3,135.2,118.8,139.9,121.5Z",
    fill: "#242424"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6923",
    "data-name": "Group 6923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    d: "M150.1,182.1h-5.8c-.3-2.9-.5-4.9-.5-5.2.1-.5-5.8-15.9-6.3-17.2-.6-1.3-2.7-4.7-3-7.9s3.9-4.5,3.9-4.5c5.7,1,7.6,8.8,7.6,8.8s2.4,15.9,3.6,20.3A27.165,27.165,0,0,1,150.1,182.1Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6668",
    "data-name": "Path 6668",
    d: "M147.2,160l-8.7,3.6s-8-19.7-1.3-17.5S146.9,152.4,147.2,160Z",
    fill: "#2daa57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6924",
    "data-name": "Group 6924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6669",
    "data-name": "Path 6669",
    d: "M145.3,169.3c-.3,2-1.3,8.9-1.1,10.8,0,.3.2,1,.4,2H123.7c.6-2,1.1-3.7,1.4-4.8,1-3.4,0-4.3-.5-6.9a42.716,42.716,0,0,0-1.7-5.3c-.3-.8-.5-1.5-.8-2.3a56.516,56.516,0,0,1-1.6-7.4c-1.3-8,4.9-8.8,4.9-8.8a61.918,61.918,0,0,0,6.3-1.7l6.3,1.3a5.725,5.725,0,0,1,1.5.9h0a12.987,12.987,0,0,1,1.4,1.2,31.527,31.527,0,0,1,3.4,4.9l1.2,2.1c1.3,2.2,2.2,4,2.2,6C147.7,163.2,145.5,167.3,145.3,169.3Z",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6670",
    "data-name": "Path 6670",
    d: "M138.1,146.1s3.9,6.7,2.5,7.2c-1.5.5-9.2-1.2-12.2-7.5C128.4,145.8,133.4,143.5,138.1,146.1Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6671",
    "data-name": "Path 6671",
    d: "M137.5,149.2s-3.5,1.5-6.7-3.4c0,0,.8-5.5-.9-8.7-1.8-3.2,7.9,3.8,7.9,3.8a10.828,10.828,0,0,0-.3,1.6,8.806,8.806,0,0,0-.2,1.7,8.083,8.083,0,0,0-.1,1.6A7.34,7.34,0,0,0,137.5,149.2Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6672",
    "data-name": "Path 6672",
    d: "M128.8,156.7c-.7,3.7-5.9,8.3-5.9,8.3-.3-.8-.5-1.5-.8-2.3A34.5,34.5,0,0,0,128.8,156.7Z",
    fill: "#3d3f62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6925",
    "data-name": "Group 6925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6673",
    "data-name": "Path 6673",
    d: "M127.5,159.7c-.3,1.3-1.8,15-1.7,15.5.1.3.8,3.4,1.6,6.9h-6.7a16.24,16.24,0,0,1-1-5.2c.4-4.6-1.1-19.3-1.1-19.3s-1.4-8.9,6-10c0,0,4.4.6,4.6,3.8S127.9,158.3,127.5,159.7Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6674",
    "data-name": "Path 6674",
    d: "M118,161.5l9.1,2.1s7.3-14.1.7-16.7C121,144.3,116.4,153.9,118,161.5Z",
    fill: "#2daa57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6928",
    "data-name": "Group 6928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6927",
    "data-name": "Group 6927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6926",
    "data-name": "Group 6926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6675",
    "data-name": "Path 6675",
    d: "M139.1,122.3s7.9,2.9,2.9,16.6-15.3-2.3-13.8-10.8C129.8,119.7,139.1,122.3,139.1,122.3Z",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6931",
    "data-name": "Group 6931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6930",
    "data-name": "Group 6930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6929",
    "data-name": "Group 6929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6676",
    "data-name": "Path 6676",
    d: "M143.2,130.6a18.453,18.453,0,0,1-10.9,3.9,41.936,41.936,0,0,0-1.8,5s-6.7-11.4,1-17.2C139.1,116.6,146.1,128.2,143.2,130.6Z",
    fill: "#242424"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6934",
    "data-name": "Group 6934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6933",
    "data-name": "Group 6933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6932",
    "data-name": "Group 6932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6677",
    "data-name": "Path 6677",
    d: "M133.2,135.3c0-1-.5-3.4-2.1-2.8-1.5.6-.2,5.3.9,5.1C132,137.7,133.2,137.7,133.2,135.3Z",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6678",
    "data-name": "Path 6678",
    d: "M137.1,145.6a8.307,8.307,0,0,1-5.2-4.7c3,3.9,5.3,3.4,5.3,3.4C137.2,144.7,137.1,145.1,137.1,145.6Z",
    fill: "#997761"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6955",
    "data-name": "Group 6955",
    transform: "translate(-38 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -82.67, 104.9)",
    filter: "url(#Union_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3-2",
    "data-name": "Union 3",
    d: "M5845.831,2970.4a40,40,0,1,1,13.4-.112l-6.73,12.116Z",
    transform: "translate(-5405.63 -2882.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974",
    "data-name": "Ellipse 2974",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(386.5 113.5)",
    fill: "#f17072"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 10.7,
    y2: 11.2,
    transform: "translate(397.1 123.9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 10.7,
    x2: 11.2,
    transform: "translate(396.9 124.2)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6954",
    "data-name": "Group 6954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6937",
    "data-name": "Group 6937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6679",
    "data-name": "Path 6679",
    d: "M388.5,181.9h-3.8c-.1-.2-.1-.3-.2-.4-1.1-2.7-7-8.8-7-8.8h0v.1h0c-.2.9-1.4,5.3-2,9H349.7c-.1-.3-.1-.7-.2-1a25.577,25.577,0,0,1-.5-2.7v-.6a17.861,17.861,0,0,1,0-4.3c-.1.2-.6,2.1-1.3,4.4-.4,1.3-.8,2.7-1.2,4.1h-6.1l7.7-22.1,3.6-1.8c1.5-.7,3.3-1.7,4.9-2.6a17.1,17.1,0,0,1,2.3-1.2h.1c1.1-.5,1.9-.8,1.9-.8h.5c1.6-.1,6.4-.6,8-.7h.5a21.291,21.291,0,0,1,2.5.9.1.1,0,0,1,.1.1c.1,0,.1,0,.2.1.1,0,.2.1.3.1.2.1.5.2.7.3.1,0,.2.1.3.1a48.157,48.157,0,0,1,6.3,2.8c.5.3,1.9,3.1,3.6,6.5C385.5,169.3,387.7,177.8,388.5,181.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6938",
    "data-name": "Group 6938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6680",
    "data-name": "Path 6680",
    d: "M369.5,151.9c-.1,3.5-6.8,5.4-6.8,5.4s-2.8-3.5-2.1-3.9c.3-.1.4-.7.4-1.2v-2l2.2-2.2c2.1-2.1,5.1-4.8,5.1-3.7v.2C367.6,146.8,369.5,151.9,369.5,151.9Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6939",
    "data-name": "Group 6939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6681",
    "data-name": "Path 6681",
    d: "M366.9,146.8h0s-.3.4-.8,1.1a14.269,14.269,0,0,1-5.2,4.3v-1.6a1.952,1.952,0,0,1-.7-.1,21.17,21.17,0,0,1,1.5-2.1l1.4-.4Z",
    fill: "#997761"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6940",
    "data-name": "Group 6940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6682",
    "data-name": "Path 6682",
    d: "M368.2,144.2a22.865,22.865,0,0,1-1.3,2.5h0a8.837,8.837,0,0,1-.8,1.1c-1.1,1.2-3.2,2.8-5.2,2.7a1.952,1.952,0,0,1-.7-.1,3.306,3.306,0,0,1-2.3-1.6c-4.2-8.2-1.2-14.9-1.2-14.9s11.5-3.2,13.3.2C371.3,136.6,369.6,141.3,368.2,144.2Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6941",
    "data-name": "Group 6941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6683",
    "data-name": "Path 6683",
    d: "M356.8,133.9s-1.1-.1-1.3-2.1c-.3-2,.3-2.5.3-2.5a40.629,40.629,0,0,1,6.4-2.2c1.7-.3,5.9-.5,6.9.6,0,0,2.4-.6,3,3.4,1,6.3-3.5,12.4-3.5,12.4s0-4.1-.9-4.6-1.7.7-1.7.7l-1.8.3s2.8-6.1-.6-6.3S358.7,134.3,356.8,133.9Z",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6942",
    "data-name": "Group 6942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6684",
    "data-name": "Path 6684",
    d: "M366,137.9c.2-1.8,3.4-2.5,3.2-.6s-1.8,3.7-2.6,3.6C365.9,140.9,365.9,139.3,366,137.9Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6943",
    "data-name": "Group 6943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6685",
    "data-name": "Path 6685",
    d: "M385.2,163.6c-1.1-3.4-2-6.1-2.4-6.4-.7-.5-6.4-2.1-9.1-3.1-.1,0-.2-.1-.3-.1-.2-.1-.5-.2-.7-.3-.1,0-.2-.1-.3-.1s-.1,0-.2-.1a.1.1,0,0,1-.1-.1h0c-.2.3-1.5,1.7-3,3.8-2.8,3.9-6.4,10.3-5.8,16.3.2,1.9.4,4.6.8,7.7,0,.2.1.5.1.7h12.5a78.538,78.538,0,0,1,.8-9h0v-.1h0s3,4.7,3.2,9.2h7.9A108.849,108.849,0,0,0,385.2,163.6Z",
    fill: "#404347"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6944",
    "data-name": "Group 6944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6686",
    "data-name": "Path 6686",
    d: "M358.6,154.3s-.9,3.2-2.2,11h0c0,.3-.1.5-.1.8v.1c0,.2-.1.4-.1.6v.1a.756.756,0,0,1-.1.4c0,.3-.1.6-.1,1-.5,3.2-1.1,8.3-1.7,13.8h-5a22.042,22.042,0,0,1-.5-3.8v.1c-.4,1.1-.8,2.3-1.3,3.4,0,.1-.1.2-.1.3h-8.5l8.5-22.3c.2-.1,2.4-1.3,3.8-2,1.5-.7,3.4-1.6,5.1-2.4a22.892,22.892,0,0,1,2.3-1.1Z",
    fill: "#404347"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6945",
    "data-name": "Group 6945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    "data-name": "Path 6687",
    d: "M370.2,162.1l-3.3,1.8,1.4,1.4-3.1,16.6H364c-.4-3.4-.7-6.4-.9-8.4-.9-9.1,8.3-19.4,8.8-20.1.4.2.9.3,1.4.5Z",
    fill: "#53575c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6946",
    "data-name": "Group 6946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6688",
    "data-name": "Path 6688",
    d: "M358.7,154.2a108.072,108.072,0,0,0-2.6,14c-.5,3.2-1.1,8.3-1.7,13.8h-.5l-.6-15.7,1.6-1.7-1.4-1.7,3-7.6c.8-.4,1.6-.7,2.2-1Z",
    fill: "#53575c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6949",
    "data-name": "Group 6949"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6413",
    "data-name": "Rectangle 6413",
    width: 39.6,
    height: 41.04,
    transform: "translate(354.64 143.8)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6948",
    "data-name": "Group 6948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6947",
    "data-name": "Group 6947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    d: "M372.2,153.5l-2.7-1.6s-.1,1.5-6.8,5.4l1.9,5.4Z",
    fill: "#e5e5e5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6950",
    "data-name": "Group 6950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    "data-name": "Path 6690",
    d: "M360.9,152.6a12.3,12.3,0,0,0,1.8,4.6l-3.7,4.9-.3-7.9Z",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6951",
    "data-name": "Group 6951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6691",
    "data-name": "Path 6691",
    d: "M362.7,157.2a14.917,14.917,0,0,1,.5,3.7,3.482,3.482,0,0,1-2.7-.1A9.6,9.6,0,0,1,362.7,157.2Z",
    fill: "#b74242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6952",
    "data-name": "Group 6952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6692",
    "data-name": "Path 6692",
    d: "M361.8,167.1a68.969,68.969,0,0,0-.5,14.9h-3.2c0-.6-.1-1.3-.1-2a51.019,51.019,0,0,1,3-19.4l1.6-.4C362.7,160.1,362.2,164.7,361.8,167.1Z",
    fill: "#b74242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6953",
    "data-name": "Group 6953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6693",
    "data-name": "Path 6693",
    d: "M349,173.5c-.1,2.5-.1,4.7-.1,4.7h0v.1c-.4,1.1-.8,2.3-1.3,3.4-.1-1.3-.1-2.6-.1-3.8.2-6.9,2.3-10.5,2.3-10.5A26.51,26.51,0,0,0,349,173.5Z",
    fill: "#323436"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6961",
    "data-name": "Group 6961",
    transform: "translate(-38 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -82.67, 104.9)",
    filter: "url(#Union_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2-2",
    "data-name": "Union 2",
    d: "M5845.831,2970.4a40,40,0,1,1,13.4-.112l-6.73,12.116Z",
    transform: "translate(-5520.63 -2882.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976",
    "data-name": "Ellipse 2976",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(271.5 113.5)",
    fill: "#f17072"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 10.7,
    y2: 11.2,
    transform: "translate(282.1 123.9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 10.7,
    x2: 11.2,
    transform: "translate(281.9 124.2)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6960",
    "data-name": "Group 6960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6694",
    "data-name": "Path 6694",
    d: "M272.2,165.3a14.62,14.62,0,0,0-8.9-8.3c-.8-.3-2.2-.7-3.7-1.2-2.7-.9-5.6-1.8-5.6-1.8h-9.2s-3.2,1.1-6.6,2.3h0c-3.1,1.1-6.4,2.3-7.6,2.9-2.3,1.2-6.2,9.5-7,10.4a80.018,80.018,0,0,0-4,7.3h10c1.1-1.8,1.9-3.2,1.9-3.2s.6,1.4,1.4,3.2h31.9a47.5,47.5,0,0,0,.8-4.8s1.7,2.3,3.6,4.8h9.2A79.462,79.462,0,0,1,272.2,165.3Z",
    fill: "#435468"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6956",
    "data-name": "Group 6956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    d: "M250.5,128.6s7.2,1.1,6.1,12.5c-1.1,11.3-7.5,10.4-7.9,10.4s-6.4.2-6.9-13.6C241.8,137.8,241.6,127.6,250.5,128.6Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6957",
    "data-name": "Group 6957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6696",
    "data-name": "Path 6696",
    d: "M256.7,137.8s.8-.8,1.1,0c.3.9-1.1,4.7-1.1,4.9,0,0-.1.3-.3.1C256.1,142.7,256.7,137.8,256.7,137.8Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6958",
    "data-name": "Group 6958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M242,137.7s-.8-.9-1.1,0,1,4.7,1,4.9c0,0,.1.3.3.2C242.5,142.5,242,137.7,242,137.7Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6698",
    "data-name": "Path 6698",
    d: "M256.7,139.6l-1,1.4s0-3-.1-3.5c-.2-.5-.4-1.9-.6-2.3-.1-.3-6.2-2-11.6.5,0,0,.2,2.2-.3,2.4s-.3,3.6-.3,3.6l-.9-1s-1.3-8.7-1-9.6,1.3-6.4,12.4-3.1c0,0,3.4-.7,4.1,1.6C258.2,131.9,256.7,139.6,256.7,139.6Z",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6699",
    "data-name": "Path 6699",
    d: "M254.9,153.8l-.9-.5c-.5-1-.1-5.3-.1-5.3s-9.2-2.3-8.9-.6c.3,1.8-.8,6-.8,6l-4.7,2.3s5,13.5,10.8,11.8,8-12.3,8-12.3Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6700",
    "data-name": "Path 6700",
    d: "M245,149.5a5.548,5.548,0,0,0,4.1,1.9c1.7,0,2.9-.5,4.6-2.1a4.812,4.812,0,0,1-4.6,3.4S246.3,153.1,245,149.5Z",
    fill: "#997761"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/img5.58f92cc9ada51dca0034b0a969480489.svg";
export { ForwardRef as ReactComponent };